import { render, staticRenderFns } from "./modalMarginApproval.vue?vue&type=template&id=fa8ca3ac&scoped=true"
import script from "./modalMarginApproval.vue?vue&type=script&lang=js"
export * from "./modalMarginApproval.vue?vue&type=script&lang=js"
import style0 from "./modalMarginApproval.vue?vue&type=style&index=0&id=fa8ca3ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8ca3ac",
  null
  
)

export default component.exports